(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  const mobileDevice = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const update = () => {
    document.querySelectorAll('template[data-desktop-hero-video]').forEach((template) => {
      const wrapper = template.parentElement;
      const section = wrapper.closest('.shopify-section');
      const visible = desktop.matches && !mobileDevice && (!section || getComputedStyle(section).display !== 'none');
      let video = wrapper.querySelector('video');
      if (!visible) {
        if (video) { video.pause(); video.remove(); }
        return;
      }
      if (!video) {
        wrapper.appendChild(template.content.cloneNode(true));
        video = wrapper.querySelector('video');
      }
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      if (reducedMotion.matches) { video.pause(); return; }
      video.play()?.catch(() => {});
    });
  };
  desktop.addEventListener('change', update);
  reducedMotion.addEventListener('change', update);
  window.addEventListener('pageshow', update);
  document.addEventListener('shopify:section:load', update);
  update();
})();
